<template>
  <v-responsive>
    <v-container justify="center">
      <v-card class="mx-auto" max-width="auto">
        <v-card-title>Setting Employees</v-card-title>
        <v-divider></v-divider>
        <v-container>
          <v-responsive v-if="multi_on != 'Y'">
            <v-row align="center" >
              <v-col cols="12" md="3" sm="3">
                <v-autocomplete
                  v-model="form_search.branch_id"
                  :items="default_data.branchs"
                  item-text="branch_name"
                  item-value="branch_id"
                  outlined
                  dense
                  label="Branch"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <v-autocomplete
                  v-model="form_search.cost_center_id"
                  :items="default_data.costcenters"
                  item-text="cost_center_name"
                  item-value="cost_center_id"
                  outlined
                  dense
                  label="Cost center"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <v-autocomplete
                  v-model="form_search.department_id"
                  :items="default_data.departments"
                  item-text="department_name"
                  item-value="department_id"
                  outlined
                  dense
                  label="Department"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <v-autocomplete
                  v-model="form_search.position_id"
                  :items="default_data.positions"
                  item-text="position_name"
                  item-value="position_id"
                  outlined
                  dense
                  label="Posiiton"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -15px;">
              <v-col cols="12" md="3" sm="3">
                <v-autocomplete
                  v-model="form_search.att_range_id"
                  :items="default_data.attranges"
                  item-text="att_range_name"
                  item-value="att_range_id"
                  outlined
                  dense
                  label="Time Att. Range"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <v-select
                  v-model="form_search.mobile_att"
                  :items="mobile_access"
                  label="ลงเวลาผ่านมือถือ"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" sm="3" hidden>
                <v-autocomplete
                  v-model="form_search.asset"
                  :items="default_data.assets_all"
                  item-text="asset_name"
                  item-value="asset_id"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Asset"
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" sm="3" hidden>
                <v-select
                  v-model="search_365"
                  :items="microsoft"
                  label="Microsoft"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="3" sm="3">
                <v-text-field
                v-model="form_search.search"
                label="Search option"
                outlined
                dense
                clearable
          ></v-text-field>
              </v-col>
            </v-row>

            <v-row style="margin-top: -15px;" hidden>
              <v-col cols="2" md="2" sm="2" style="margin-top:-40px;">
                <v-checkbox
                  v-model="form_search.sff"
                  label="SFF"
                  value="Y"
                ></v-checkbox>
              </v-col>
              <v-col cols="5" md="5" sm="5" style="margin-top:-30px;">
                <v-autocomplete
                  v-if="form_search.sff == 'Y'"
                  :items="default_data.sff_area"
                  multiple
                  v-model="form_search.sff_area"
                  item-text="area_name"
                  item-value="area_id"
                  label="SFF Area"
                  outlined
                  dense
                  chips
                  small-chips
                ></v-autocomplete>
              </v-col>
              <v-col cols="5" md="5" sm="5" style="margin-top:-30px;">
                <v-autocomplete
                  v-if="form_search.sff == 'Y'"
                  :items="default_data.access_hour"
                  v-model="form_search.sff_hour"
                  item-text="access_hour_name"
                  item-value="access_hour_id"
                  label="SFF Hr. Range"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -15px;" hidden>
              <v-col cols="2" md="2" sm="2" style="margin-top:-40px;">
                <v-checkbox
                  v-model="form_search.dhl"
                  label="DHL"
                  value="Y"
                ></v-checkbox>
              </v-col>
              <v-col cols="5" md="5" sm="5" style="margin-top:-30px;">
                <v-autocomplete
                  v-if="form_search.dhl == 'Y'"
                  :items="default_data.dhl_area"
                  multiple
                  v-model="form_search.dhl_area"
                  item-text="area_name"
                  item-value="area_id"
                  label="DHL Area"
                  outlined
                  dense
                  chips
                  small-chips
                ></v-autocomplete>
              </v-col>

              <v-col cols="5" md="5" sm="5" style="margin-top:-30px;">
                <v-autocomplete
                  v-if="form_search.dhl == 'Y'"
                  :items="default_data.access_hour"
                  v-model="form_search.dhl_hour"
                  item-text="access_hour_name"
                  item-value="access_hour_id"
                  label="DHL Hr. Range"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -15px;" hidden>
              <v-col cols="2" md="2" sm="2" style="margin-top:-40px;">
                <v-checkbox
                  v-model="form_search.svc"
                  label="SVC"
                  value="Y"
                ></v-checkbox>
              </v-col>
              <v-col cols="5" md="5" sm="5" style="margin-top:-30px;">
                <v-autocomplete
                  v-if="form_search.svc == 'Y'"
                  :items="default_data.svc_area"
                  multiple
                  v-model="form_search.svc_area"
                  item-text="area_name"
                  item-value="area_id"
                  label="SVC Area"
                  outlined
                  dense
                  chips
                  small-chips
                ></v-autocomplete>
              </v-col>
              <v-col cols="5" md="5" sm="5" style="margin-top:-30px;">
                <v-autocomplete
                  v-if="form_search.svc == 'Y'"
                  :items="default_data.access_hour"
                  v-model="form_search.svc_hour"
                  item-text="access_hour_name"
                  item-value="access_hour_id"
                  label="SVC Hr. Range"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -15px;" hidden>
              <v-col cols="2" md="2" sm="2" style="margin-top:-40px;">
                <v-checkbox
                  v-model="form_search.outside"
                  label="OUTSIDE"
                  value="Y"
                ></v-checkbox>
              </v-col>
            </v-row>

           

            <v-row justify="center" >
              <v-btn color="success" class="mr-4" @click="getUAC()">
                Search
              </v-btn>
              <v-btn color="warning" class="mr-4" @click="reset()">
                Reset
              </v-btn>
            </v-row>
          </v-responsive>
        </v-container>
        <v-container fluid>
          <v-row hidden>
              <v-col
            cols="12"
            sm="8"
            md="8"
          >
            <v-switch
              v-model="multi_on"
              label="Multi-Select"
              color="info"
              value="Y"
              hide-details
            ></v-switch>
            </v-col >
            <v-col v-if="multi_on == 'Y'" cols="11"  sm="4"
            md="4" align="right">
              <v-btn color="success" @click="multi_update()">
                Multi-update
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="multi_on == 'Y'">
            <v-col cols="12" md="3" sm="3">
              <v-autocomplete
                  v-model="form_search.branch_id"
                  :items="default_data.branchs"
                  item-text="branch_name"
                  item-value="branch_id"
                  outlined
                  dense
                  label="Branch"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <v-autocomplete
                  v-model="form_search.cost_center_id"
                  :items="default_data.costcenters"
                  item-text="cost_center_name"
                  item-value="cost_center_id"
                  outlined
                  dense
                  label="Cost center"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" sm="3">
                <v-autocomplete
                  v-model="form_search.department_id"
                  :items="default_data.departments"
                  item-text="department_name"
                  item-value="department_id"
                  outlined
                  dense
                  label="Department"
                ></v-autocomplete>
              </v-col>
            <v-col cols="12" md="3" sm="3">
              <v-autocomplete
                  v-model="form_search.position_id"
                  :items="default_data.positions"
                  item-text="position_name"
                  item-value="position_id"
                  outlined
                  dense
                  label="Posiiton"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12">
            <v-row justify="center" >
              <v-btn color="success" class="mr-4" @click="getUAC()">
                Search
              </v-btn>
              <v-btn color="warning" class="mr-4" @click="reset()">
                Reset
              </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-data-table
            :headers="header_table"
            :show-select="multi_on == 'Y'"
            item-key="emp_id"
            v-model="select_emp"
            :items="data"
            :items-per-page="10"
            :loading="isLoading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.emp_name_en`]="{ item }">{{
              item.emp_name_en + " " + item.emp_surname_en
            }}</template>
            <template v-slot:[`item.mobile_att`]="{ item }">
              {{ item.att_range_name }}
              <br />
              <v-icon color="green" small>mdi-laptop</v-icon>
              <v-icon
                :color="item.mobile_att == 'Y' ? 'green' : ''"
                class="ml-2"
                small
                >mdi-cellphone</v-icon
              >
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                
                x-small
                fab
                @click="personal_data(item)"
              >
                <v-icon small color="primary">mdi-chevron-right</v-icon>

              </v-btn>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-container>
    <v-dialog
      v-model="dialog_open"
      max-width="1000px"
      persistent
      v-if="dialog_open"
    >
      <v-form method="post" id="nativeForm" v-model="valid">
        <v-card>
          <v-card-title>
            Personal Information
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
              
                <v-col cols="12" md="6" class="text-left">
                  <v-text >
                    Employee name(EN) : <b class="text-left text-uppercase text--primary"> {{this.selectedItem.emp_id +' '+ this.selectedItem.emp_name_en }}
                    {{ this.selectedItem.emp_surname_en }}</b></v-text
                  >
                </v-col>
                <v-col cols="12" md="6" class="text-left">
                
                    Position : <b class="text-left text-uppercase text--primary"> {{ this.selectedItem.position_name }}</b>
            
                </v-col>
              </v-row>
            
              <v-row class="text-left">
                <v-col cols="12">
              
                <v-card-title>
                      <u> Management </u>
                    </v-card-title>
                  
                      <v-row style="margin-top: -10px;margin-left: 10px;">
                        <v-card-subtitle class="text-left text--h2">
                      เวลาเข้างาน 
                    </v-card-subtitle>
                      </v-row>
                    <v-row>
                        <v-col
                          class="d-flex"
                          cols="12"
                          md="4"
                          sm="4"
                          style="margin-top: -10px;margin-left: 20px;"
                        >
                        <v-select
                            :label="default_personal.time_label"
                            v-model="send_data.att_range_id"
                            :items="default_data.attranges"
                            
                            item-text="att_range_name"
                            item-value="att_range_id"
                            :rules="att_range_idR"
                            outlined
                            dense
                          >
                       </v-select>
                        </v-col>
                      </v-row>
                     <v-divider></v-divider>
                      <v-row style="margin-top: -10px;margin-left: 10px;">
                          <v-card-subtitle class="text-left ">
                      Devices 
                    </v-card-subtitle>
                      </v-row>
                      <v-row>
                          <v-col
                          class="d-flex"
                          cols="12"
                          md="4"
                          sm="4"
                          style="margin-top: -20px;margin-left: 30px;"
                        >
                         <v-switch
                            v-model="send_data.mobile_att"
                            :label="default_personal.mobile_att == 'Y'
                                ? 'ลงเวลาผ่านมือถือได้'
                                : 'ลงเวลาผ่านมือถือไม่ได้'
                            "
                            color="success"
                            inset
                            value="Y"
                            hide-details
                          ></v-switch>
                        </v-col>
              </v-row>
                        
                      </v-col></v-row>
                      <v-divider></v-divider>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="clear()">
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :disabled="!valid"
              @click="update_person()"
              
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
      <v-card color="primary" dark>
        <v-card-text>
          <span class="mt-1 white--text">Loading</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-responsive>
</template>

<script>
import { applyEach } from "async";
import { select } from "async";
import axios from "axios";
import { multiply } from "lodash";
import { indexOf } from "lodash";
import { mapState, mapMutations } from "vuex";
const url = `${process.env.VUE_APP_ROOT_API}/api`;
export default {
  computed: {
    ...mapState(["isLoading"]),
    ...mapState(["snackbar"]),
  },
  beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
    this.getdata_default();
    this.get_selectionID()
  },
  mounted() {
    // this.getFilter();
    this.getdata_default();
  },
  data() {
  
    return {
      select_emp:[],
      multi_on:'N',
      disable:false,
      dialog_multi:false,
      selected:'',
      multi_select:{
        emp_id:[],
        branch_id:'',
        department_id:'',
        position_id:'',
      },
      fab: false,
      mobile_access: [
        { label: "ลงเวลาผ่านมือถือได้", value: "Y" },
        { label: "ลงเวลาผ่านมือถือไม่ได้", value: "N" },
      ],
      microsoft: [
        { label: "Microsoft 365 Business Basic", value: "3" },
        { label: "Microsoft 365 Business Standard", value: "10" },
      ],
      att_range_idR: [(v) => !!v || "Time Att Range is required"],
      valid: false,
      time:[], 
      send_data: {
        emp_id: "",
        mobile_att: "",
        att_range_id: "",
      },
      default_personal:{
        mobile_att:'',
        time_att:'',
        id:'',
        time_label:''
      },
      dialog_loading: false,
      search_365: "",
      dialog_open: false,
      dialog_: false,
      default_data: [],
      person_data: [],
      tk: null,
      selectedItem: null,
      form_search: {
        branch_id: "",
        att_range_id: "",
        search: "",
        cost_center_id: "",
        department_id: "",
        position_id: "",
        sff: "N",
        sff_area: [],
        dhl: "N",
        dhl_area: [],
        dhl_hour: "",
        svc: "N",
        svc_area: [],
        svc_hour: "",
        outside: "N",
        asset: [],
        mobile_att: "",
      },
      edit_person: {},
      data: [],
      header_table: [
        {
          text: "ID",
          value: "emp_id",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "NAME",
          value: "emp_name_en",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "COST CENTER",
          value: "cost_center_name",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "BRANCH",
          value: "branch_name",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "POSITION",
          value: "position_name",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "PERMISSION",
          value: "mobile_att",
          class: "text-uppercase blue darken-3 white--text",
        },
        {
          text: "ACTION",
          value: "action",
          class: "text-uppercase blue darken-3 white--text text-center",
          sortable: false,
        },
      ],
      dialog: false,
    };
  },
  methods: {
    async multi_update(){
      console.log("select emp",this.select_emp)
      this.multi_select.branch_id = this.form_search.branch_id
      this.multi_select.department_id = this.form_search.department_id
      this.multi_select.position_id = this.form_search.position_id
      // this.multi_select.emp_id = this.select_emp.each.emp_id
      for(let i = 0;i < this.select_emp.length ;i++){
        if(this.select_emp.length > 0){
          this.multi_select.emp_id[i] = this.select_emp[i].emp_id
        }else{
        
        this.multi_select.emp_id = []
        }
      }
      
      // this.select_emp.map((each)=>{
      //   let id=""
      //   id =  each.emp_id
      //   this.multi_select.emp_id = id
      // })

console.log('multi update',this.multi_select)
    },
    async getdata_default() {
      await axios
        .get(url + "/uac/data", this.tk)
        .then((response) => {
          this.default_data = response.data;
          console.log('default',this.default_data)
          this.time = response.data.attranges
        })
        .catch((error) => {
          console.log(error);
        });
    },
 
    async getUAC() {
      console.log('search',this.form_search)
      // this.dialog_loading=true

      await axios
        .post(url + "/uac/view", this.form_search, this.tk)
        .then((response) => {
          this.data = response.data;
          if(response.data != null){
            this.disable = false 
          }
        
        })
        .catch((error) => {
          console.log(error);
        });
      this.dialog_loading = false;
    },
    async personal_data(item) {

      this.dialog_open = true
      this.selectedItem = item;
    this.multi_select.emp_id = this.selectedItem.emp_id
      this.send_data.emp_id = this.selectedItem.emp_id
      
      this.default_personal.mobile_att = this.selectedItem.mobile_att
     
      this.default_personal.time_label = this.selectedItem.att_range_name

      this.time.map((each) => {
        if(this.selectedItem.att_range_name == each.att_range_name){
          this.default_personal.time_att = each.att_range_id
     
          
        }
      });
    },
  
    async update_person() {
      this.dialog_loading = true;
      await axios
        .post(url + "/uac/setting-employee/save", this.send_data, this.tk)
        .then((response) => {
          this.person_data = response.data;
          this.default_data = [this.default_data]
          this.dialog_open = false;
          this.dialog_loading = false;
          this.clear();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clear() {
      this.dialog_open = false;
      this.send_data.emp_id = "";
      this.send_data.mobile_att = "";
      this.send_data.att_range_id = "";
    },
    reset() {
      this.multi_select.emp_id = []
      console.log(this.multi_select)
      this.form_search.branch_id = "";
      this.form_search.att_range_id = "";
      this.form_search.search = "";
      this.form_search.cost_center_id = "";
      this.form_search.department_id = "";
      this.form_search.position_id = "";
      this.form_search.sff = "N";
      this.form_search.sff_area = [];
      this.form_search.dhl = "N";
      this.form_search.dhl_area = [];
      this.form_search.dhl_hour = "";
      this.form_search.svc = "N";
      this.form_search.svc_area = [];
      this.form_search.svc_hour = "";
      this.form_search.outside = "N";
      this.form_search.asset = [];
      this.form_search.mobile_att = "";
      this.search_365 = "";
      
    },
  },
};
</script>
